import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ onAuth }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }

    const sessionId = match[1];

    const processSession = async () => {
      try {
        const res = await api.post('/auth/session', { session_id: sessionId });
        if (onAuth) onAuth(res.data);
        // Clear hash and navigate
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Auth callback failed:', err);
        navigate('/login');
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1f2e] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <span className="text-2xl font-bold text-white">Casino<span className="text-[#4d7cfe]">IQ</span></span>
        <p className="text-[#a0a8b8] text-sm mt-3">Completing sign in...</p>
      </div>
    </div>
  );
}
